import { useFocusWithin } from "@react-aria/interactions";
import React, { useEffect, useMemo, useRef, useState } from "react";
import utilities from "../../../../utils/utilities";
import TestContentWrapper from "./TestContentWrapper";
// import Timer from "../../../../components/common/Timer";
import Button from "../../../../components/sub-component/Button";
import Radio from "../../../../components/sub-component/Radio";
import ProcessingIndicator from "../../../../components/common/ProcessingIndicator";
import ReactQuillBubble from "../../../../components/sub-component/ReactQuillBubble";
import { ReactComponent as AlertIcon } from "../../../../assets/icons/pricing/alert-circle.svg";

export default function Big5PersonalityTestCS(props) {
  const { active_question } = props.test;

  const [selectedChoice, setSelectedChoice] = useState(null);
  const [error, setError] = useState();
  const hasLoggedRef = useRef(null);

  const alphabets = ["A", "B", "C", "D", "E", "F"];
  const choices = active_question?.choices?.map((item, index) => ({
    ...item,
    option: alphabets[index],
  }));

  const onQuestionSubmit = () => {
    const data = {
      assess_id: props?.assessmentId,
      ques_id: active_question?.id,
      answer: selectedChoice?.id,
    };
    if (props.onConfirm) props.onConfirm(data);
  };

  useMemo(() => {
    if (!active_question) return;
    if (selectedChoice) setSelectedChoice(null);
    if (error) setError(null);
  }, [active_question]);

  // const [timeDuration, setTimeDuration] = useState(0);
  // const [isSkipModalOpen, setIsSkipModalOpen] = useState(false);

  // const { focusWithinProps } = useFocusWithin({
  //   onBlurWithin: () => setIsSkipModalOpen(false),
  // });

  // useMemo(() => {
  //   if (timeDuration === 0) setIsSkipModalOpen(false);
  // }, [timeDuration]);

  // const timeoutMessage = useMemo(
  //   () =>
  //     active_question &&
  //     timeDuration <= 0 && (
  //       <div className="timeout-message">
  //         <AlertIcon style={{ width: "24px", height: "24px" }} />
  //         <span className="body-2 dark-100 text-start ms-2">
  //           Your time for this question is expired. You cannot attempt this
  //           question anymore! Press next to continue the assessment.
  //         </span>
  //       </div>
  //     ),
  //   [timeDuration]
  // );

  const QuestionTextMemo = useMemo(
    () =>
      active_question && (
        <ReactQuillBubble
          value={`I see myself as someone who ...  <br/>${active_question.text}`}
          className="ql-editor-skill-candidate-side text-read-only "
        />
      ),
    [active_question],
  );

  useEffect(() => {
    hasLoggedRef.current = null;
  }, [props.currentQuestionNo]);

  return (
    <>
      {/* {timeoutMessage} */}
      <TestContentWrapper
        title={utilities.toTitleCase("big_5_personality_test")}
        // duration={timeDuration}
        answer={selectedChoice}
        currentQuestion={props.currentQuestionNo}
        totalQuestions={props.totalQuestions || 0}
        onSubmit={(action) => {
          if (action === "skip") {
            const data = { assess_id: props?.assessmentId };
            if (props.onConfirm) props.onConfirm(data);
          } else {
            onQuestionSubmit();
          }
        }}
        processing={props.processing}
      >
        {!active_question ? (
          <div className="align-self-center">
            <ProcessingIndicator className="medium-indicator" />
          </div>
        ) : (
          <div className="assessment-test-container position-relative">
            <div
              className="assessment-test-questions-container"
              // style={{
              //   opacity: timeDuration <= 0 ? "0.3" : "1",
              //   pointerEvents: timeDuration <= 0 ? "none" : "auto",
              // }}
            >
              <span className="subtitle-2 dark-100 text-start">
                {QuestionTextMemo}
              </span>
            </div>

            <div
              className="assessment-test-answers-container"
              style={{ position: "sticky", top: "15px" }}
            >
              {/* <div
                className="w-100 d-flex align-items-center justify-content-between"
                style={{
                  opacity: timeDuration <= 0 ? "0.3" : "1",
                  pointerEvents: timeDuration <= 0 ? "none" : "auto",
                }}
              >
                <span className="subtitle-2 dark-100">Select only one</span>
                <Timer
                  useServeTime
                  serveTime={active_question?.serve_time}
                  serverTime={active_question?.server_time}
                  questionDuration={active_question?.duration}
                  getUpdatedTime={(duration) => {
                    if (hasLoggedRef.current !== props.currentQuestionNo) {
                      hasLoggedRef.current = props.currentQuestionNo;
                    }
                    setTimeDuration(duration);
                  }}
                />
              </div> */}
              <span className="subtitle-2 dark-100">Select only one</span>

              <div
                className="w-100"
                // style={{
                //   opacity: timeDuration <= 0 ? "0.3" : "1",
                //   pointerEvents: timeDuration <= 0 ? "none" : "auto",
                // }}
              >
                {choices.map((choice, _index) => {
                  const isSelected = choice.id === selectedChoice?.id;
                  return (
                    <Radio
                      style={{
                        marginTop: "16px",
                        background: isSelected ? "#ECEDF1" : "#F6F5F8",
                      }}
                      key={_index}
                      varrient="radio-with-input"
                      onChangeRadioOption={() => setSelectedChoice(choice)}
                      checked={isSelected}
                      radioValue={choice}
                      optionValue={choice.option}
                      value={choice.text}
                      readonly
                      placeholder=""
                      disabled={props.processing}
                    />
                  );
                })}
              </div>

              <div className="w-100 d-flex justify-content-end align-items-end mt-4">
                {/* <div tabIndex={-1} {...focusWithinProps}>
                  {isSkipModalOpen ? (
                    <Button
                      processing={props.processing}
                      btn="ragular-btn"
                      varrient="primary"
                      title="Skip Question?"
                      style={{ width: "max-content", height: "40px" }}
                      onClick={() => {
                        const data = { assess_id: props?.assessmentId };
                        if (props.onConfirm) props.onConfirm(data);
                        setIsSkipModalOpen(false);
                      }}
                    />
                  ) : (
                    <Button
                      processing={props.processing}
                      btn="ragular-btn"
                      varrient="primary"
                      title={
                        props.currentQuestionNo === props.totalQuestions || 0
                          ? "Submit"
                          : "Next"
                      }
                      style={{ width: "max-content", height: "40px" }}
                      onClick={() => {
                        if (
                          (!selectedChoice || selectedChoice === "") &&
                          (timeDuration === null || timeDuration > 0)
                        ) {
                          setIsSkipModalOpen(true);
                        } else if (!isSkipModalOpen) {
                          onQuestionSubmit();
                          setIsSkipModalOpen(false);
                        }
                      }}
                    />
                  )}
                </div> */}
                <Button
                  processing={props.processing}
                  disabled={!selectedChoice?.id}
                  btn="ragular-btn"
                  varrient="primary"
                  title={
                    props.currentQuestionNo === props.totalQuestions || 0
                      ? "Submit"
                      : "Next"
                  }
                  style={{ width: "max-content", height: "40px" }}
                  onClick={onQuestionSubmit}
                />
              </div>
              <span className="body-3 danger-text mt-2">{error}</span>
            </div>
          </div>
        )}
      </TestContentWrapper>
    </>
  );
}
